module.exports = __webpack_public_path__ + "static/img/14000120.21f7dfaf.png";